import { render, staticRenderFns } from "./ConsentSummary.vue?vue&type=template&id=c901f76c&scoped=true&"
import script from "./ConsentSummary.vue?vue&type=script&lang=js&"
export * from "./ConsentSummary.vue?vue&type=script&lang=js&"
import style0 from "./ConsentSummary.vue?vue&type=style&index=0&id=c901f76c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c901f76c",
  null
  
)

export default component.exports